export default __webpack_public_path__ + "static/media/thermometer.341398b1.svg";